import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { RootRedirect } from '@/components/auth/RootRedirect'
import { SessionManager } from '@/components/auth/SessionManager'
import { LoginPage } from '@/pages/LoginPage'
import { AcceptInvitePage } from '@/pages/AcceptInvitePage'
import { DashboardPage } from '@/pages/DashboardPage'
import { UsersPage } from '@/pages/UsersPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { ProfilePage } from '@/pages/ProfilePage'
import { CompleteRegistrationPage } from '@/pages/CompleteRegistrationPage'
import { AuthProvidersPage } from '@/pages/AuthProvidersPage'
import { NetAppConfiguration } from '@/pages/NetAppConfiguration'
import QueryTemplates from '@/pages/QueryTemplates'
import { GeneralSettings } from '@/pages/GeneralSettings'
import { HelpdeskSettingsPage } from '@/pages/HelpdeskSettingsPage'
import { TwoFactorVerifyPage } from '@/pages/TwoFactorVerifyPage'
import { TwoFactorSetupPage } from '@/pages/TwoFactorSetupPage'
import { SyslogSettingsPage } from '@/pages/SyslogSettingsPage'
import EmailSettingsPage from '@/pages/EmailSettingsPage'

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <SessionManager>
            <Routes>
            {/* Root route - redirects based on auth status */}
            <Route path="/" element={<RootRedirect />} />
            
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/2fa" element={<TwoFactorVerifyPage />} />
            <Route path="/login/2fa-setup" element={<TwoFactorSetupPage />} />
            <Route path="/complete-registration" element={<CompleteRegistrationPage />} />
            <Route path="/invite/:token" element={<AcceptInvitePage />} />
            
            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/settings" element={<SettingsPage />} />
              
              {/* Admin routes */}
              <Route element={<ProtectedRoute requiredRole="admin" />}>
                <Route path="/users" element={<UsersPage />} />
                <Route path="/settings/users" element={<UsersPage />} />
                <Route path="/settings/auth-providers" element={<AuthProvidersPage />} />
                <Route path="/settings/netapp-config" element={<NetAppConfiguration />} />
                <Route path="/settings/netapp-config/:configId" element={<NetAppConfiguration />} />
                <Route path="/settings/query-templates" element={<QueryTemplates />} />
                <Route path="/settings/helpdesk" element={<HelpdeskSettingsPage />} />
                <Route path="/settings/helpdesk/:configId" element={<HelpdeskSettingsPage />} />
                <Route path="/settings/general" element={<GeneralSettings />} />
                <Route path="/settings/syslog" element={<SyslogSettingsPage />} />
                <Route path="/settings/email" element={<EmailSettingsPage />} />
              </Route>
            </Route>
            
            {/* Catch all - redirect to root to handle auth-based redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SessionManager>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App